import CircleFilledSvg from '@assets/images/svg/circle-filled.svg';
import React from 'react';
import { View } from 'react-native';

export interface CircleFilledIconProps {
    size?: number;
    color?: string;
}

export const CircleFilledIcon = React.memo<CircleFilledIconProps>(function CircleFilledIcon({
    size = 8,
    color = '#B3B3B3',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CircleFilledSvg width={size} height={size} color={color} />
        </View>
    );
});

export default CircleFilledIcon;


